<template>
  <div id="app">
    <el-container>
      <el-header>
        <header-logo />
        <header-feedback />
        <header-user />
      </el-header>
      <el-container style="overflow: hidden">
        <aside-menu />
        <el-main :class="[isBgGray && 'bg-gray']">
          <!-- <breadcrumb></breadcrumb> -->
          <transition name="fade" mode="out-in">
            <router-view :key="key" />
          </transition>
        </el-main>
      </el-container>
    </el-container>
    <message-carousel ref="MessageCarousel" :data="unReadList" />

    <!-- 权益等级全局弹窗 -->
    <LevelEquityDialog ref="LevelEquityDialog" :partnerList="equityPartnerList" />
  </div>
</template>

<script>
import { userAgent } from '@bike/fe-utils'
import HeaderLogo from '@/components/HeaderLogo.vue'
import HeaderUser from '@/components/HeaderUser.vue'
import HeaderFeedback from './components/HeaderFeedback.vue'
import AsideMenu from '@/components/AsideMenu.vue'
// import Breadcrumb from '@/components/Breadcrumb.vue'
import { showMobileTip, showBrowserTip } from '@/utils/browser_tip'
import MessageCarousel from './components/message/MessageCarousel.vue'
import LevelEquityDialog from './components/LevelEquity/index.vue'
import message from '@/mixins/message'
import levelEquity from '@/mixins/levelEquity'
import bgGrayPath from '@/enums/bgGrayPath'
import { isPathIncluded } from '@/utils'

export default {
  name: 'App',
  components: {
    MessageCarousel,
    LevelEquityDialog,
    HeaderLogo,
    HeaderUser,
    HeaderFeedback,
    AsideMenu,
  },
  mixins: [message, levelEquity],
  data() {
    return {
      noMessagePaths: ['/data/assets/battery-panel-detail', '/data/assets/spock-panel-detail'],
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    isBgGray() {
      return isPathIncluded(this.key, bgGrayPath)
    },
  },
  mounted() {
    if (userAgent.isMobile()) {
      showMobileTip()
    } else {
      showBrowserTip()
    }
    this.globalDialogInit()
  },

  methods: {
    // 展示消息弹窗
    async showMessage() {
      await this.getUserUnreadMessageList()
      if (!(this.unReadList || []).length) return
      if (this.noMessagePaths.includes(this.key)) return
      setTimeout(() => {
        this.$refs.MessageCarousel && this.$refs.MessageCarousel.show()
      })
    },
  },
}
</script>

<style scoped lang="scss">
#app,
.el-container,
.el-main {
  height: 100%;
}

.el-header {
  padding: 0;
  display: flex;
  background: #383a40;
}

.el-aside {
  background: #26282b;
}

.el-aside,
.el-main {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.el-main {
  padding: 24px;
  &.bg-gray {
    background: #fafafc;
  }
  > div:first-child {
    min-width: 1176px; // 1140 - 216 - 24 * 2
    overflow-x: scroll;
  }
}
</style>
